import { css as dt, html as ut, LitElement as pt } from "lit";
import { property as b, query as ft } from "lit/decorators.js";
import { ifDefined as F } from "lit/directives/if-defined.js";
const _t = '.sr-only{position:absolute;margin:-1px;border-width:0;padding:0;width:1px;height:1px;overflow:hidden;white-space:nowrap;clip:rect(0,0,0,0)}.truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:host .checkbox__label{line-height:calc(1.875 * var(--muse-base-unit, 1rem));font-family:Fira Sans,sans-serif;font-size:calc(1.25 * var(--muse-base-unit, 1rem));font-weight:400;display:flex;gap:12px;align-items:center;width:fit-content;color:#222}@media (width < 768px){:host .checkbox__label{line-height:calc(1.5 * var(--muse-base-unit, 1rem));font-family:Fira Sans,sans-serif;font-size:calc(1 * var(--muse-base-unit, 1rem));font-weight:400}}:host .checkbox__input{-webkit-appearance:none;-moz-appearance:none;appearance:none;display:inline-block;flex-shrink:0;place-content:center;margin:0;border:1px solid #356799;border-radius:4px;width:24px;height:24px}:host .checkbox__input:disabled{border:1px solid #a8b4bf}:host .checkbox__input:not(:checked){background:#fff}:host .checkbox__input:checked{background-color:#356799}:host .checkbox__input:checked:before{display:block;transform:translate(5%,5%);background-image:url(data:image/svg+xml;base64,PHN2ZyBuYW1lPSJjaGVjayIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZD0iTTguMywyMC43IEM4LDIwLjcgNy44LDIwLjYgNy42LDIwLjQgTDAuMywxMy4xIEMtMC4xLDEyLjcgLTAuMSwxMi4xIDAuMywxMS43IEMwLjcsMTEuMyAxLjMsMTEuMyAxLjcsMTEuNyBMOC4zLDE4LjMgTDIyLjMsNC4zIEMyMi43LDMuOSAyMy4zLDMuOSAyMy43LDQuMyBDMjQuMSw0LjcgMjQuMSw1LjMgMjMuNyw1LjcgTDksMjAuNCBDOC44LDIwLjYgOC42LDIwLjcgOC4zLDIwLjcgWiIvPjwvc3ZnPg==);background-repeat:no-repeat;width:20px;height:20px;content:"";filter:invert(100%)}:host .checkbox__input:not(:disabled):focus,:host .checkbox__input:not(:disabled):focus-visible{outline:2px dashed #7194b7;outline-offset:1px}:host .checkbox__input:checked:disabled{background-color:#a8b4bf}:host([disabled]) .checkbox__label{line-height:calc(1.875 * var(--muse-base-unit, 1rem));font-family:Fira Sans,sans-serif;font-size:calc(1.25 * var(--muse-base-unit, 1rem));font-weight:400;display:flex;gap:12px;align-items:center;width:fit-content;color:#222;color:#a8b4bf}@media (width < 768px){:host([disabled]) .checkbox__label{line-height:calc(1.5 * var(--muse-base-unit, 1rem));font-family:Fira Sans,sans-serif;font-size:calc(1 * var(--muse-base-unit, 1rem));font-weight:400}}';
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const L = globalThis, D = L.ShadowRoot && (L.ShadyCSS === void 0 || L.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, rt = Symbol(), W = /* @__PURE__ */ new WeakMap();
let $t = class {
  constructor(o, t, e) {
    if (this._$cssResult$ = !0, e !== rt) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = o, this.t = t;
  }
  get styleSheet() {
    let o = this.o;
    const t = this.t;
    if (D && o === void 0) {
      const e = t !== void 0 && t.length === 1;
      e && (o = W.get(t)), o === void 0 && ((this.o = o = new CSSStyleSheet()).replaceSync(this.cssText), e && W.set(t, o));
    }
    return o;
  }
  toString() {
    return this.cssText;
  }
};
const mt = (o) => new $t(typeof o == "string" ? o : o + "", void 0, rt), gt = (o, t) => {
  if (D) o.adoptedStyleSheets = t.map((e) => e instanceof CSSStyleSheet ? e : e.styleSheet);
  else for (const e of t) {
    const s = document.createElement("style"), i = L.litNonce;
    i !== void 0 && s.setAttribute("nonce", i), s.textContent = e.cssText, o.appendChild(s);
  }
}, q = D ? (o) => o : (o) => o instanceof CSSStyleSheet ? ((t) => {
  let e = "";
  for (const s of t.cssRules) e += s.cssText;
  return mt(e);
})(o) : o;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const { is: vt, defineProperty: yt, getOwnPropertyDescriptor: bt, getOwnPropertyNames: At, getOwnPropertySymbols: Et, getPrototypeOf: xt } = Object, E = globalThis, Q = E.trustedTypes, wt = Q ? Q.emptyScript : "", Z = E.reactiveElementPolyfillSupport, M = (o, t) => o, I = { toAttribute(o, t) {
  switch (t) {
    case Boolean:
      o = o ? wt : null;
      break;
    case Object:
    case Array:
      o = o == null ? o : JSON.stringify(o);
  }
  return o;
}, fromAttribute(o, t) {
  let e = o;
  switch (t) {
    case Boolean:
      e = o !== null;
      break;
    case Number:
      e = o === null ? null : Number(o);
      break;
    case Object:
    case Array:
      try {
        e = JSON.parse(o);
      } catch {
        e = null;
      }
  }
  return e;
} }, nt = (o, t) => !vt(o, t), G = { attribute: !0, type: String, converter: I, reflect: !1, hasChanged: nt };
Symbol.metadata ?? (Symbol.metadata = Symbol("metadata")), E.litPropertyMetadata ?? (E.litPropertyMetadata = /* @__PURE__ */ new WeakMap());
class A extends HTMLElement {
  static addInitializer(t) {
    this._$Ei(), (this.l ?? (this.l = [])).push(t);
  }
  static get observedAttributes() {
    return this.finalize(), this._$Eh && [...this._$Eh.keys()];
  }
  static createProperty(t, e = G) {
    if (e.state && (e.attribute = !1), this._$Ei(), this.elementProperties.set(t, e), !e.noAccessor) {
      const s = Symbol(), i = this.getPropertyDescriptor(t, s, e);
      i !== void 0 && yt(this.prototype, t, i);
    }
  }
  static getPropertyDescriptor(t, e, s) {
    const { get: i, set: n } = bt(this.prototype, t) ?? { get() {
      return this[e];
    }, set(r) {
      this[e] = r;
    } };
    return { get() {
      return i == null ? void 0 : i.call(this);
    }, set(r) {
      const h = i == null ? void 0 : i.call(this);
      n.call(this, r), this.requestUpdate(t, h, s);
    }, configurable: !0, enumerable: !0 };
  }
  static getPropertyOptions(t) {
    return this.elementProperties.get(t) ?? G;
  }
  static _$Ei() {
    if (this.hasOwnProperty(M("elementProperties"))) return;
    const t = xt(this);
    t.finalize(), t.l !== void 0 && (this.l = [...t.l]), this.elementProperties = new Map(t.elementProperties);
  }
  static finalize() {
    if (this.hasOwnProperty(M("finalized"))) return;
    if (this.finalized = !0, this._$Ei(), this.hasOwnProperty(M("properties"))) {
      const e = this.properties, s = [...At(e), ...Et(e)];
      for (const i of s) this.createProperty(i, e[i]);
    }
    const t = this[Symbol.metadata];
    if (t !== null) {
      const e = litPropertyMetadata.get(t);
      if (e !== void 0) for (const [s, i] of e) this.elementProperties.set(s, i);
    }
    this._$Eh = /* @__PURE__ */ new Map();
    for (const [e, s] of this.elementProperties) {
      const i = this._$Eu(e, s);
      i !== void 0 && this._$Eh.set(i, e);
    }
    this.elementStyles = this.finalizeStyles(this.styles);
  }
  static finalizeStyles(t) {
    const e = [];
    if (Array.isArray(t)) {
      const s = new Set(t.flat(1 / 0).reverse());
      for (const i of s) e.unshift(q(i));
    } else t !== void 0 && e.push(q(t));
    return e;
  }
  static _$Eu(t, e) {
    const s = e.attribute;
    return s === !1 ? void 0 : typeof s == "string" ? s : typeof t == "string" ? t.toLowerCase() : void 0;
  }
  constructor() {
    super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
  }
  _$Ev() {
    var t;
    this._$ES = new Promise((e) => this.enableUpdating = e), this._$AL = /* @__PURE__ */ new Map(), this._$E_(), this.requestUpdate(), (t = this.constructor.l) == null || t.forEach((e) => e(this));
  }
  addController(t) {
    var e;
    (this._$EO ?? (this._$EO = /* @__PURE__ */ new Set())).add(t), this.renderRoot !== void 0 && this.isConnected && ((e = t.hostConnected) == null || e.call(t));
  }
  removeController(t) {
    var e;
    (e = this._$EO) == null || e.delete(t);
  }
  _$E_() {
    const t = /* @__PURE__ */ new Map(), e = this.constructor.elementProperties;
    for (const s of e.keys()) this.hasOwnProperty(s) && (t.set(s, this[s]), delete this[s]);
    t.size > 0 && (this._$Ep = t);
  }
  createRenderRoot() {
    const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
    return gt(t, this.constructor.elementStyles), t;
  }
  connectedCallback() {
    var t;
    this.renderRoot ?? (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), (t = this._$EO) == null || t.forEach((e) => {
      var s;
      return (s = e.hostConnected) == null ? void 0 : s.call(e);
    });
  }
  enableUpdating(t) {
  }
  disconnectedCallback() {
    var t;
    (t = this._$EO) == null || t.forEach((e) => {
      var s;
      return (s = e.hostDisconnected) == null ? void 0 : s.call(e);
    });
  }
  attributeChangedCallback(t, e, s) {
    this._$AK(t, s);
  }
  _$EC(t, e) {
    var s;
    const i = this.constructor.elementProperties.get(t), n = this.constructor._$Eu(t, i);
    if (n !== void 0 && i.reflect === !0) {
      const r = (((s = i.converter) == null ? void 0 : s.toAttribute) !== void 0 ? i.converter : I).toAttribute(e, i.type);
      this._$Em = t, r == null ? this.removeAttribute(n) : this.setAttribute(n, r), this._$Em = null;
    }
  }
  _$AK(t, e) {
    var s;
    const i = this.constructor, n = i._$Eh.get(t);
    if (n !== void 0 && this._$Em !== n) {
      const r = i.getPropertyOptions(n), h = typeof r.converter == "function" ? { fromAttribute: r.converter } : ((s = r.converter) == null ? void 0 : s.fromAttribute) !== void 0 ? r.converter : I;
      this._$Em = n, this[n] = h.fromAttribute(e, r.type), this._$Em = null;
    }
  }
  requestUpdate(t, e, s) {
    if (t !== void 0) {
      if (s ?? (s = this.constructor.getPropertyOptions(t)), !(s.hasChanged ?? nt)(this[t], e)) return;
      this.P(t, e, s);
    }
    this.isUpdatePending === !1 && (this._$ES = this._$ET());
  }
  P(t, e, s) {
    this._$AL.has(t) || this._$AL.set(t, e), s.reflect === !0 && this._$Em !== t && (this._$Ej ?? (this._$Ej = /* @__PURE__ */ new Set())).add(t);
  }
  async _$ET() {
    this.isUpdatePending = !0;
    try {
      await this._$ES;
    } catch (e) {
      Promise.reject(e);
    }
    const t = this.scheduleUpdate();
    return t != null && await t, !this.isUpdatePending;
  }
  scheduleUpdate() {
    return this.performUpdate();
  }
  performUpdate() {
    var t;
    if (!this.isUpdatePending) return;
    if (!this.hasUpdated) {
      if (this.renderRoot ?? (this.renderRoot = this.createRenderRoot()), this._$Ep) {
        for (const [n, r] of this._$Ep) this[n] = r;
        this._$Ep = void 0;
      }
      const i = this.constructor.elementProperties;
      if (i.size > 0) for (const [n, r] of i) r.wrapped !== !0 || this._$AL.has(n) || this[n] === void 0 || this.P(n, this[n], r);
    }
    let e = !1;
    const s = this._$AL;
    try {
      e = this.shouldUpdate(s), e ? (this.willUpdate(s), (t = this._$EO) == null || t.forEach((i) => {
        var n;
        return (n = i.hostUpdate) == null ? void 0 : n.call(i);
      }), this.update(s)) : this._$EU();
    } catch (i) {
      throw e = !1, this._$EU(), i;
    }
    e && this._$AE(s);
  }
  willUpdate(t) {
  }
  _$AE(t) {
    var e;
    (e = this._$EO) == null || e.forEach((s) => {
      var i;
      return (i = s.hostUpdated) == null ? void 0 : i.call(s);
    }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
  }
  _$EU() {
    this._$AL = /* @__PURE__ */ new Map(), this.isUpdatePending = !1;
  }
  get updateComplete() {
    return this.getUpdateComplete();
  }
  getUpdateComplete() {
    return this._$ES;
  }
  shouldUpdate(t) {
    return !0;
  }
  update(t) {
    this._$Ej && (this._$Ej = this._$Ej.forEach((e) => this._$EC(e, this[e]))), this._$EU();
  }
  updated(t) {
  }
  firstUpdated(t) {
  }
}
A.elementStyles = [], A.shadowRootOptions = { mode: "open" }, A[M("elementProperties")] = /* @__PURE__ */ new Map(), A[M("finalized")] = /* @__PURE__ */ new Map(), Z == null || Z({ ReactiveElement: A }), (E.reactiveElementVersions ?? (E.reactiveElementVersions = [])).push("2.0.4");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const N = globalThis, j = N.trustedTypes, J = j ? j.createPolicy("lit-html", { createHTML: (o) => o }) : void 0, lt = "$lit$", $ = `lit$${Math.random().toFixed(9).slice(2)}$`, at = "?" + $, St = `<${at}>`, y = document, k = () => y.createComment(""), C = (o) => o === null || typeof o != "object" && typeof o != "function", V = Array.isArray, Mt = (o) => V(o) || typeof (o == null ? void 0 : o[Symbol.iterator]) == "function", R = `[ 	
\f\r]`, S = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, Y = /-->/g, K = />/g, g = RegExp(`>|${R}(?:([^\\s"'>=/]+)(${R}*=${R}*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`, "g"), X = /'/g, tt = /"/g, ht = /^(?:script|style|textarea|title)$/i, x = Symbol.for("lit-noChange"), d = Symbol.for("lit-nothing"), et = /* @__PURE__ */ new WeakMap(), v = y.createTreeWalker(y, 129);
function ct(o, t) {
  if (!V(o) || !o.hasOwnProperty("raw")) throw Error("invalid template strings array");
  return J !== void 0 ? J.createHTML(t) : t;
}
const kt = (o, t) => {
  const e = o.length - 1, s = [];
  let i, n = t === 2 ? "<svg>" : t === 3 ? "<math>" : "", r = S;
  for (let h = 0; h < e; h++) {
    const l = o[h];
    let c, u, a = -1, f = 0;
    for (; f < l.length && (r.lastIndex = f, u = r.exec(l), u !== null); ) f = r.lastIndex, r === S ? u[1] === "!--" ? r = Y : u[1] !== void 0 ? r = K : u[2] !== void 0 ? (ht.test(u[2]) && (i = RegExp("</" + u[2], "g")), r = g) : u[3] !== void 0 && (r = g) : r === g ? u[0] === ">" ? (r = i ?? S, a = -1) : u[1] === void 0 ? a = -2 : (a = r.lastIndex - u[2].length, c = u[1], r = u[3] === void 0 ? g : u[3] === '"' ? tt : X) : r === tt || r === X ? r = g : r === Y || r === K ? r = S : (r = g, i = void 0);
    const _ = r === g && o[h + 1].startsWith("/>") ? " " : "";
    n += r === S ? l + St : a >= 0 ? (s.push(c), l.slice(0, a) + lt + l.slice(a) + $ + _) : l + $ + (a === -2 ? h : _);
  }
  return [ct(o, n + (o[e] || "<?>") + (t === 2 ? "</svg>" : t === 3 ? "</math>" : "")), s];
};
class P {
  constructor({ strings: t, _$litType$: e }, s) {
    let i;
    this.parts = [];
    let n = 0, r = 0;
    const h = t.length - 1, l = this.parts, [c, u] = kt(t, e);
    if (this.el = P.createElement(c, s), v.currentNode = this.el.content, e === 2 || e === 3) {
      const a = this.el.content.firstChild;
      a.replaceWith(...a.childNodes);
    }
    for (; (i = v.nextNode()) !== null && l.length < h; ) {
      if (i.nodeType === 1) {
        if (i.hasAttributes()) for (const a of i.getAttributeNames()) if (a.endsWith(lt)) {
          const f = u[r++], _ = i.getAttribute(a).split($), U = /([.?@])?(.*)/.exec(f);
          l.push({ type: 1, index: n, name: U[2], strings: _, ctor: U[1] === "." ? Pt : U[1] === "?" ? Tt : U[1] === "@" ? Ut : H }), i.removeAttribute(a);
        } else a.startsWith($) && (l.push({ type: 6, index: n }), i.removeAttribute(a));
        if (ht.test(i.tagName)) {
          const a = i.textContent.split($), f = a.length - 1;
          if (f > 0) {
            i.textContent = j ? j.emptyScript : "";
            for (let _ = 0; _ < f; _++) i.append(a[_], k()), v.nextNode(), l.push({ type: 2, index: ++n });
            i.append(a[f], k());
          }
        }
      } else if (i.nodeType === 8) if (i.data === at) l.push({ type: 2, index: n });
      else {
        let a = -1;
        for (; (a = i.data.indexOf($, a + 1)) !== -1; ) l.push({ type: 7, index: n }), a += $.length - 1;
      }
      n++;
    }
  }
  static createElement(t, e) {
    const s = y.createElement("template");
    return s.innerHTML = t, s;
  }
}
function w(o, t, e = o, s) {
  var i, n;
  if (t === x) return t;
  let r = s !== void 0 ? (i = e.o) == null ? void 0 : i[s] : e.l;
  const h = C(t) ? void 0 : t._$litDirective$;
  return (r == null ? void 0 : r.constructor) !== h && ((n = r == null ? void 0 : r._$AO) == null || n.call(r, !1), h === void 0 ? r = void 0 : (r = new h(o), r._$AT(o, e, s)), s !== void 0 ? (e.o ?? (e.o = []))[s] = r : e.l = r), r !== void 0 && (t = w(o, r._$AS(o, t.values), r, s)), t;
}
class Ct {
  constructor(t, e) {
    this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = e;
  }
  get parentNode() {
    return this._$AM.parentNode;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  u(t) {
    const { el: { content: e }, parts: s } = this._$AD, i = ((t == null ? void 0 : t.creationScope) ?? y).importNode(e, !0);
    v.currentNode = i;
    let n = v.nextNode(), r = 0, h = 0, l = s[0];
    for (; l !== void 0; ) {
      if (r === l.index) {
        let c;
        l.type === 2 ? c = new T(n, n.nextSibling, this, t) : l.type === 1 ? c = new l.ctor(n, l.name, l.strings, this, t) : l.type === 6 && (c = new Lt(n, this, t)), this._$AV.push(c), l = s[++h];
      }
      r !== (l == null ? void 0 : l.index) && (n = v.nextNode(), r++);
    }
    return v.currentNode = y, i;
  }
  p(t) {
    let e = 0;
    for (const s of this._$AV) s !== void 0 && (s.strings !== void 0 ? (s._$AI(t, s, e), e += s.strings.length - 2) : s._$AI(t[e])), e++;
  }
}
class T {
  get _$AU() {
    var t;
    return ((t = this._$AM) == null ? void 0 : t._$AU) ?? this.v;
  }
  constructor(t, e, s, i) {
    this.type = 2, this._$AH = d, this._$AN = void 0, this._$AA = t, this._$AB = e, this._$AM = s, this.options = i, this.v = (i == null ? void 0 : i.isConnected) ?? !0;
  }
  get parentNode() {
    let t = this._$AA.parentNode;
    const e = this._$AM;
    return e !== void 0 && (t == null ? void 0 : t.nodeType) === 11 && (t = e.parentNode), t;
  }
  get startNode() {
    return this._$AA;
  }
  get endNode() {
    return this._$AB;
  }
  _$AI(t, e = this) {
    t = w(this, t, e), C(t) ? t === d || t == null || t === "" ? (this._$AH !== d && this._$AR(), this._$AH = d) : t !== this._$AH && t !== x && this._(t) : t._$litType$ !== void 0 ? this.$(t) : t.nodeType !== void 0 ? this.T(t) : Mt(t) ? this.k(t) : this._(t);
  }
  O(t) {
    return this._$AA.parentNode.insertBefore(t, this._$AB);
  }
  T(t) {
    this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
  }
  _(t) {
    this._$AH !== d && C(this._$AH) ? this._$AA.nextSibling.data = t : this.T(y.createTextNode(t)), this._$AH = t;
  }
  $(t) {
    var e;
    const { values: s, _$litType$: i } = t, n = typeof i == "number" ? this._$AC(t) : (i.el === void 0 && (i.el = P.createElement(ct(i.h, i.h[0]), this.options)), i);
    if (((e = this._$AH) == null ? void 0 : e._$AD) === n) this._$AH.p(s);
    else {
      const r = new Ct(n, this), h = r.u(this.options);
      r.p(s), this.T(h), this._$AH = r;
    }
  }
  _$AC(t) {
    let e = et.get(t.strings);
    return e === void 0 && et.set(t.strings, e = new P(t)), e;
  }
  k(t) {
    V(this._$AH) || (this._$AH = [], this._$AR());
    const e = this._$AH;
    let s, i = 0;
    for (const n of t) i === e.length ? e.push(s = new T(this.O(k()), this.O(k()), this, this.options)) : s = e[i], s._$AI(n), i++;
    i < e.length && (this._$AR(s && s._$AB.nextSibling, i), e.length = i);
  }
  _$AR(t = this._$AA.nextSibling, e) {
    var s;
    for ((s = this._$AP) == null ? void 0 : s.call(this, !1, !0, e); t && t !== this._$AB; ) {
      const i = t.nextSibling;
      t.remove(), t = i;
    }
  }
  setConnected(t) {
    var e;
    this._$AM === void 0 && (this.v = t, (e = this._$AP) == null || e.call(this, t));
  }
}
class H {
  get tagName() {
    return this.element.tagName;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  constructor(t, e, s, i, n) {
    this.type = 1, this._$AH = d, this._$AN = void 0, this.element = t, this.name = e, this._$AM = i, this.options = n, s.length > 2 || s[0] !== "" || s[1] !== "" ? (this._$AH = Array(s.length - 1).fill(new String()), this.strings = s) : this._$AH = d;
  }
  _$AI(t, e = this, s, i) {
    const n = this.strings;
    let r = !1;
    if (n === void 0) t = w(this, t, e, 0), r = !C(t) || t !== this._$AH && t !== x, r && (this._$AH = t);
    else {
      const h = t;
      let l, c;
      for (t = n[0], l = 0; l < n.length - 1; l++) c = w(this, h[s + l], e, l), c === x && (c = this._$AH[l]), r || (r = !C(c) || c !== this._$AH[l]), c === d ? t = d : t !== d && (t += (c ?? "") + n[l + 1]), this._$AH[l] = c;
    }
    r && !i && this.j(t);
  }
  j(t) {
    t === d ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
  }
}
class Pt extends H {
  constructor() {
    super(...arguments), this.type = 3;
  }
  j(t) {
    this.element[this.name] = t === d ? void 0 : t;
  }
}
class Tt extends H {
  constructor() {
    super(...arguments), this.type = 4;
  }
  j(t) {
    this.element.toggleAttribute(this.name, !!t && t !== d);
  }
}
class Ut extends H {
  constructor(t, e, s, i, n) {
    super(t, e, s, i, n), this.type = 5;
  }
  _$AI(t, e = this) {
    if ((t = w(this, t, e, 0) ?? d) === x) return;
    const s = this._$AH, i = t === d && s !== d || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, n = t !== d && (s === d || i);
    i && this.element.removeEventListener(this.name, this, s), n && this.element.addEventListener(this.name, this, t), this._$AH = t;
  }
  handleEvent(t) {
    var e;
    typeof this._$AH == "function" ? this._$AH.call(((e = this.options) == null ? void 0 : e.host) ?? this.element, t) : this._$AH.handleEvent(t);
  }
}
class Lt {
  constructor(t, e, s) {
    this.element = t, this.type = 6, this._$AN = void 0, this._$AM = e, this.options = s;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(t) {
    w(this, t);
  }
}
const st = N.litHtmlPolyfillSupport;
st == null || st(P, T), (N.litHtmlVersions ?? (N.litHtmlVersions = [])).push("3.2.0");
const Ot = (o, t, e) => {
  const s = (e == null ? void 0 : e.renderBefore) ?? t;
  let i = s._$litPart$;
  if (i === void 0) {
    const n = (e == null ? void 0 : e.renderBefore) ?? null;
    s._$litPart$ = i = new T(t.insertBefore(k(), n), n, void 0, e ?? {});
  }
  return i._$AI(o), i;
};
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class O extends A {
  constructor() {
    super(...arguments), this.renderOptions = { host: this }, this.o = void 0;
  }
  createRenderRoot() {
    var t;
    const e = super.createRenderRoot();
    return (t = this.renderOptions).renderBefore ?? (t.renderBefore = e.firstChild), e;
  }
  update(t) {
    const e = this.render();
    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this.o = Ot(e, this.renderRoot, this.renderOptions);
  }
  connectedCallback() {
    var t;
    super.connectedCallback(), (t = this.o) == null || t.setConnected(!0);
  }
  disconnectedCallback() {
    var t;
    super.disconnectedCallback(), (t = this.o) == null || t.setConnected(!1);
  }
  render() {
    return x;
  }
}
var it;
O._$litElement$ = !0, O.finalized = !0, (it = globalThis.litElementHydrateSupport) == null || it.call(globalThis, { LitElement: O });
const ot = globalThis.litElementPolyfillSupport;
ot == null || ot({ LitElement: O });
(globalThis.litElementVersions ?? (globalThis.litElementVersions = [])).push("4.1.0");
const z = Symbol("internals");
function Nt(o) {
  class t extends o {
    /** @ignore */
    get [z]() {
      return this._internals || (this._internals = this.attachInternals()), this._internals;
    }
  }
  return t;
}
function jt(o) {
  const t = class extends o {
    /**
     * Method that returns the current state of the form-associated element.
     * Usually this is the same as the form value, so we provide a default.
     */
    getFormState() {
      return this.getFormValue();
    }
    /**
     * A lifecycle callback that will be invoked every time a reactive value changes on the current lit element
     *
     * @ignore
     */
    updated() {
      this.syncValue();
    }
    /**
     * Synchronizes the form value and state with the element's value.
     */
    syncValue() {
      this[z].setFormValue(this.getFormValue(), this.getFormState());
    }
  };
  return t.formAssociated = !0, t;
}
function Ht(o, t, e) {
  const s = e ? `${t}-${e}` : t;
  customElements.get(s) ? console.warn(
    `WARN: You are importing '${s}' more than once, which is not supported. Please remove the duplicated import.`
  ) : customElements.define(s, o);
}
function Rt(o) {
  class t extends o {
    requestUpdate(s, i, n) {
      super.requestUpdate(s, i, n), this.syncValidity();
    }
    firstUpdated(s) {
      super.firstUpdated(s), this.syncValidity();
    }
    getValidity() {
      return this.checkboxEl ? (this.checkboxEl.checked = this.checked, this.checkboxEl.required = this.required, {
        validity: this.checkboxEl.validity,
        validityMessage: this.checkboxEl.validationMessage
      }) : { validity: {}, validityMessage: "" };
    }
    syncValidity() {
      if (!this.checkboxEl) return;
      const { validity: s, validityMessage: i } = this.getValidity();
      this[z].setValidity(s, i, this.checkboxEl);
    }
  }
  return t;
}
var It = Object.defineProperty, m = (o, t, e, s) => {
  for (var i = void 0, n = o.length - 1, r; n >= 0; n--)
    (r = o[n]) && (i = r(t, e, i) || i);
  return i && It(t, e, i), i;
};
const Dt = "muse-checkbox", B = class B extends Rt(
  jt(Nt(pt))
) {
  constructor() {
    super(...arguments), this.required = !1, this.checked = !1, this.disabled = !1, this.hideLabelText = !1, this.variant = "font-body-lg", this.handleChange = (t) => {
      this._toggleChecked(), t.stopPropagation();
    };
  }
  //#region -- Base
  /**
   * @ignore
   */
  static get styles() {
    return dt([_t]);
  }
  //#endregion
  //#region -- Computed
  //#endregion
  //#region -- Lifecycles
  /**
   * @ignore
   */
  formResetCallback() {
    this.checkboxEl.removeAttribute("checked"), this._toggleChecked(!1);
  }
  //#endregion
  //#region -- Methods
  /**
   * Method that returns the current value of the form-associated element.
   *
   * @ignore
   */
  getFormValue() {
    var t;
    return (t = this.checkboxEl) != null && t.hasAttribute("checked") ? this.value || "on" : null;
  }
  /**
   * @ignore
   */
  _toggleChecked(t = !this.checkboxEl.hasAttribute("checked")) {
    this.checkboxEl.toggleAttribute("checked", t), this.dispatchEvent(
      new CustomEvent("change", { detail: { checked: t } })
    );
  }
  //#endregion
  //#region -- Render
  render() {
    return ut`
      <label class="checkbox__label">
        <input
          id="input"
          type="checkbox"
          class="checkbox__input"
          name=${this.name}
          value=${F(this.value)}
          ?required=${this.required}
          ?checked=${this.checked}
          ?disabled=${this.disabled}
          @change=${this.handleChange}
        />

        <muse-text
          variant=${this.variant}
          class="${F(this.hideLabelText && "sr-only")}"
        >
          <slot name="label"></slot>
        </muse-text>
      </label>
    `;
  }
  //#endregion
};
B.shadowRootOptions = {
  mode: "open",
  delegatesFocus: !0
};
let p = B;
m([
  b({ reflect: !0 })
], p.prototype, "name");
m([
  b({ reflect: !0 })
], p.prototype, "value");
m([
  b({ type: Boolean, reflect: !0 })
], p.prototype, "required");
m([
  b({ type: Boolean, reflect: !0 })
], p.prototype, "checked");
m([
  b({ type: Boolean, reflect: !0 })
], p.prototype, "disabled");
m([
  b({ type: Boolean, attribute: "hidelabeltext" })
], p.prototype, "hideLabelText");
m([
  b()
], p.prototype, "variant");
m([
  ft("#input")
], p.prototype, "checkboxEl");
function Wt(o) {
  Ht(p, Dt, o);
}
export {
  p as C,
  Wt as r
};
